import React from "react";
import NumberFormat from "react-number-format";
import moment from "moment"
import { Sticky, StickyContainer } from "react-sticky";

import Header from "../components/header";
import Footer from "../components/footer";
import { StepBarStatus } from "./components/statustrip";
import { commonErr } from "../common/errors";
import { getCountDownTime, convertToDateTimeObj } from "../common/common";
import { LoadingInline, LoadingOverlay } from "../common/loading";
import {
	requestPaymentWithUrl,
	requestPaymentWithUrlNew,
	getListPaymentMethod,
	requestPaymentWithMyCard,
	getListCard,
	requestAddCard,
	checkCodes,
	payWithOnlyCodes,
} from "../../model/payment";
import { getTripDetail, reserveTrip } from "../../model/car";
import { MessageBox } from "../common/messagebox";
import { IcCloseBlack, IcPlusCircle, IcInformationRed } from "../common/svg";

import logo from "../../static/images/logo.png";

import card_method from "../../static/images/payments/cards.svg";

import credit_card from "../../static/images/payments/credit-card.svg";
import visa from "../../static/images/payments/visa.svg";
import master from "../../static/images/payments/mastercard.svg";
import jcb from "../../static/images/payments/jcb.svg";

const paymentMethods = {
	MY_CARD: "Mycard",
	WALLET: "Wallet",
	INTERNATIONAL_CARD: "InternationalCard",
	DOMESTIC_BANK: "DomesticBank",
	STORE: "Store",
	TRANFER: "Tranfer",
	OFFICE: "Office",
	VOUCHER: "Voucher",
};

class MyCardMethod extends React.Component {
	constructor(props) {
		super();
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			cards: props.cards,
			trip: props.trip,
			activeCard: "",
		};
	}

	componentDidMount() {
		if (this.state.cards && this.state.cards.length > 0) {
			this.setState({
				activeCard: this.state.cards[0],
			});
			this.props.getActiveOption(this.state.cards[0]);
		} else {
			this.setState({
				activeCard: "",
			});
		}
	}
	// componentWillReceiveProps(props) {
	// 	this.setState({
	// 		cards: props.cards,
	// 		trip: props.trip
	// 	}, () => {
	//         if (this.state.cards && this.state.cards.length > 0) {
	//             this.setState({
	//                 activeCard: this.state.cards[0]
	//             })
	//         } else {
	//             this.setState({
	//                 activeCard: ""
	//             })
	//         }
	//     })
	// }

	buildImgPayment = (card) => {
		switch (card.cardBrand) {
			case "VISA":
				return <img loading="lazy" src={visa} />;
			case "MASTERCARD":
				return <img loading="lazy" src={master} />;
			case "JCB":
				return <img loading="lazy" src={jcb} />;
			default:
				return <img loading="lazy" src={credit_card} />;
		}
	};
	onCardChange = (card) => {
		this.setState({
			activeCard: card,
		});
		this.props.getActiveOption(card);
	};

	onAddCardBtn = (callbackPaths) => {
		requestAddCard(callbackPaths).then((cardResp) => {
			const { data, error, errorMessage } = cardResp.data;
			if (error >= commonErr.SUCCESS && data) {
				window.location.assign(data.linkUrl);
			} else {
				this.setState({
					err: error,
					errMsg: errorMessage,
				});
			}
		});
	};

	hideMessageBox = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	render() {
		const { trip, cards, activeCard } = this.state;

		const { err, errMsg } = this.state;
		var content;
		if (this.state.cards && this.state.cards.length > 0) {
			content = (
				<>
					<p className="text">1. Lựa chọn thẻ mà bạn muốn thanh toán</p>
					<div className="radio-payment card">
						{cards.map((card) => (
							<div key={card.cardId} className="custom-radio">
								<input
									id={`r_${card.cardId}`}
									type="radio"
									onChange={() => this.onCardChange(card)}
									name={`${card.cardName}_${card.cardId}_radio`}
									checked={activeCard.cardId === card.cardId}
								/>
								<label htmlFor={`r_${card.cardId}`}>
									<div className="card-item">
										<div className="logo-edit">
											<div className="logo">{this.buildImgPayment(card)}</div>
										</div>
										<div className="number-name">
											<p className="number">•••• •••• •••• {card.cardNumber.slice(12)}</p>
											{/* {card.cardType && <span className="card-type" style={{ textTransform: "uppercase" }}>{card.cardType}</span>} */}
											<p className="name" style={{ textTransform: "uppercase" }}>
												{card.cardName}
											</p>
										</div>
										<div className="date-remove">
											<p className="date">
												{card.cardExpiredMonth}/{card.cardExpiredYear}
											</p>
										</div>
									</div>
								</label>
							</div>
						))}
					</div>
					<p className="text">
						2. Sau khi thanh toán, bạn sẽ nhận được thông báo đặt xe thành công và thông tin chủ xe qua tin nhắn và qua
						ứng dụng/website Mioto.
					</p>
				</>
			);
		} else {
			content = (
				<div className="add-card">
					<p>Thêm thông tin thẻ của bạn</p>
					<a
						className="btn btn--s"
						onClick={() =>
							this.onAddCardBtn(
								`payment/${trip.id}?deposit=${trip.priceSummary.deposit}&timeExpired=${trip.timeExpired}`
							)
						}>
						Thêm thẻ
						<div className="wrap-svg">
							<IcPlusCircle />
						</div>
					</a>
				</div>
			);
		}

		return (
			<>
				<div className="line-payment" />
				<div className="content-payment">
					{content}
					{err === commonErr.LOADING && <LoadingOverlay />}
					<MessageBox show={errMsg !== ""} error={err} message={errMsg} hideModal={this.hideMessageBox} />
				</div>
			</>
		);
	}
}

class WalletMethod extends React.Component {
	constructor(props) {
		super();
		const { providers } = props.method;
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			activeProvider: providers[0],
		};
	}

	componentDidMount() {
		this.props.getActiveOption(this.state.activeProvider);
	}

	onProviderChange = (provider) => {
		this.setState({
			activeProvider: provider,
		});
		this.props.getActiveOption(provider);
	};

	hideMessageBox = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	render() {
		const { trip, method } = this.props;
		const { err, errMsg, activeProvider } = this.state;

		return (
			<>
				<div className="line-payment" />
				<div className="content-payment">
					<p className="text">1. Lựa chọn ví điện tử</p>
					<div className="radio-payment">
						{method.providers.map((provider, i) => (
							<div key={i} className="custom-radio">
								<input
									type="radio"
									id={`r_e_${i}`}
									name={`${method.name}_${provider.connectId}_radio`}
									checked={activeProvider.connectId === provider.connectId}
									onChange={() => this.onProviderChange(provider)}
								/>
								<label htmlFor={`r_e_${i}`}>
									<img loading="lazy" className="e-wallet" src={provider.logo} alt={provider.name} />
								</label>
							</div>
						))}
					</div>
					<p className="text">
						2. Bấm <strong>“THANH TOÁN” </strong>để chuyển hướng về ví điện tử và tiến hành đặt cọc.
					</p>
					<p className="text">3. Nhập thông tin tài khoản hoặc quét mã thanh toán.</p>
					<p className="text">
						4. Sau khi thanh toán, bạn sẽ nhận được thông báo đặt xe thành công và thông tin chủ xe qua tin nhắn và qua
						ứng dụng/ website MIOTO.
					</p>
					{err === commonErr.LOADING && <LoadingOverlay />}
					<MessageBox show={errMsg !== ""} error={err} message={errMsg} hideModal={this.hideMessageBox} />
				</div>
			</>
		);
	}
}

class InternationalMethod extends React.Component {
	constructor(props) {
		super();
		const { providers } = props.method;
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			activeProvider: providers[0],
		};
	}

	componentDidMount() {
		this.props.getActiveOption(this.state.activeProvider);
	}

	onProviderChange = (provider) => {
		this.setState({
			activeProvider: provider,
		});
		this.props.getActiveOption(provider);
	};

	hideMessageBox = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	render() {
		const { trip, method } = this.props;
		const { err, errMsg, activeProvider } = this.state;

		return (
			<>
				<div className="line-payment" />
				<div className="content-payment">
					<p className="text">
						Trên thẻ của bạn phải có các ký hiệu Visa, Master để thanh toán được bằng hình thức này
					</p>
					<div className="radio-payment">
						{method.providers.map((provider, i) => (
							<div key={i} className="custom-radio">
								<input
									type="radio"
									id={`r_inter_${i}`}
									name={`${method.name}_${provider.connectId}_radio`}
									checked={activeProvider.connectId === provider.connectId}
									onChange={() => this.onProviderChange(provider)}
								/>
								<label htmlFor={`r_inter_${i}`}>
									<img loading="lazy" className="e-wallet" src={provider.logo} alt={provider.name} />
								</label>
							</div>
						))}
					</div>
					<p className="text">
						1. Bấm <strong>“THANH TOÁN” </strong>để chuyển hướng về cổng thanh toán và tiến hành đặt cọc.
					</p>
					<p className="text">2. Nhập thông tin trên thẻ.</p>
					<p className="text">
						3. Sau khi thanh toán, bạn sẽ nhận được thông báo đặt xe thành công và thông tin chủ xe qua tin nhắn và qua
						ứng dụng/ website MIOTO.
					</p>
					{err === commonErr.LOADING && <LoadingOverlay />}
					<MessageBox show={errMsg !== ""} error={err} message={errMsg} hideModal={this.hideMessageBox} />
				</div>
			</>
		);
	}
}

class DomesticBankMethod extends React.Component {
	constructor(props) {
		super();
		const { providers } = props.method;
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			activeProvider: providers[0],
		};
	}

	componentDidMount() {
		this.props.getActiveOption(this.state.activeProvider);
	}

	onProviderChange = (provider) => {
		this.setState({
			activeProvider: provider,
		});
		this.props.getActiveOption(provider);
	};

	hideMessageBox = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	render() {
		const { trip, method } = this.props;
		const { activeProvider, err, errMsg } = this.state;

		return (
			<>
				<div className="line-payment" />
				<div className="content-payment">
					<p className="text">Trên thẻ của bạn phải có đăng ký dịch vụ thanh toán trực tuyến với ngân hàng</p>
					<div className="radio-payment">
						{method.providers.map((provider, i) => (
							<div key={i} className="custom-radio">
								<input
									id={`r_domes_${i}`}
									type="radio"
									name={`${method.name}_${provider.connectId}_radio`}
									checked={activeProvider.connectId === provider.connectId}
									onChange={() => this.onProviderChange(provider)}
								/>
								<label htmlFor={`r_domes_${i}`}>
									<img loading="lazy" className="e-wallet" src={provider.logo} alt={provider.name} />
								</label>
							</div>
						))}
					</div>
					<p className="text">
						1. Bấm <strong>“THANH TOÁN” </strong>để chuyển hướng về cổng thanh toán và tiến hành đặt cọc.
					</p>
					<p className="text">2. Nhập thông tin trên thẻ.</p>
					<p className="text">
						3. Sau khi thanh toán, bạn sẽ nhận được thông báo đặt xe thành công và thông tin chủ xe qua tin nhắn và qua
						ứng dụng/ website MIOTO.
					</p>
				</div>
			</>
		);
	}
}

class TranferMethod extends React.Component {
	constructor(props) {
		super();

		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
		};
	}

	hideMessageBox = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	render() {
		const { trip, method, expiredText } = this.props;
		const { err, errMsg } = this.state;
		const { accountAddress, accountName, bankCode, bankLogo, bankName, content } = method.data;

		return (
			<>
				<div className="line-payment" />
				<div className="content-payment">
					<p className="text">
						1. Bấm <strong>“ĐẶT CHỖ” </strong>để xác nhận lựa chọn hình thức thanh toán chuyến khoản ngân hàng.
					</p>
					<p className="text">
						2. Bạn vui lòng chuyển tiền vào tài khoản MIOTO trong vòng <span className="count-down">{expiredText}</span>{" "}
						kể từ lúc đặt chỗ
					</p>
					<div className="bank-info">
						<img loading="lazy" src={bankLogo} alt={bankName} />
						<div className="text-info">
							<p className="main">Ngân hàng: {bankName}</p>
							{/* <p>Chi nhánh: {accountAddress}</p> */}
							<p>Số tài khoản: {bankCode}</p>
							<p>Chủ tài khoản: {accountName}</p>
							<p>Nội dung chuyển khoản: {content}</p>
						</div>
					</div>
					<p className="text">
						3. Chụp lại màn hình “Chuyển khoản thành công” và gửi đến{" "}
						<a className="count-down" target="_blank" href="https://www.messenger.com/t/mioto.vn">
							MIOTO fanpage{" "}
						</a>
						hoặc{" "}
						<a className="count-down" href="mailto:contact@mioto.vn">
							contact@mioto.vn
						</a>
						. Sau khi nhận được hình chụp từ bạn hoặc có tin nhắn tiền đã vào tài khoản, MIOTO sẽ gửi thông báo đặt cọc
						thành công và thông tin chủ xe qua tin nhắn sms và ứng dụng/ website MIOTO.
					</p>
					{err === commonErr.LOADING && <LoadingOverlay />}
					<MessageBox show={errMsg !== ""} error={err} message={errMsg} hideModal={this.hideMessageBox} />
				</div>
			</>
		);
	}
}

class StoreMethod extends React.Component {
	constructor(props) {
		super();
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			codeAtStore: props.trip.reservedCode,
			isReserved: props.trip.reserved === 1,
			countdown: props.countdown,
		};
	}

	hideMessageBox = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	onReserveBtnClick = (params, linkPayment) => {
		this.setState({
			err: commonErr.LOADING,
		});

		requestPaymentWithUrl(linkPayment, params.tripId).then((paymentResp) => {
			const { data, error, errorMessage } = paymentResp.data;
			if (error >= commonErr.SUCCESS && data) {
				params.code = data.codeAtStore;
				reserveTrip(params).then((resp) => {
					const { error, errorMessage } = resp.data;
					var { isReserved } = this.state;
					if (error >= commonErr.SUCCESS) {
						isReserved = !isReserved;
						this.props.onReserveBtnClick(params);
						const errMsg = isReserved
							? `Đặt chỗ thành công, mã thanh toán của bạn là ${params.code}, vui lòng đến cửa hàng tiện lợi gần nhà để thanh toán trong vòng ${this.props.expiredText} kể từ lúc đặt chỗ.`
							: errorMessage;
						this.setState({
							err: error,
							errMsg: errMsg,
							codeAtStore: params.code,
							isReserved: isReserved,
						});
					} else {
						this.setState({
							err: error,
							errMsg: errorMessage,
						});
					}
					this.props.countDownReserve(params.tripId);
				});
			} else {
				this.setState({
					err: error,
					errMsg: errorMessage,
				});
			}
		});
	};

	render() {
		const { trip, method, expiredText } = this.props;
		const { isReserved, codeAtStore, err, errMsg } = this.state;
		return (
			<div className="content-payment">
				<div className="step-by-step">
					{isReserved ? (
						<p className="step">
							1. Mã thanh toán hóa đơn Payoo: <span className="codeAtStore">{codeAtStore}</span>
						</p>
					) : (
						<p className="step">
							1. Bấm <strong>"ĐẶT CHỖ"</strong> để nhận mã code "Thanh toán hóa đơn Payoo" (qua website và tin nhắn
							sms).
						</p>
					)}
					<p className="step">
						2. Chụp / ghi lại mã code và đến thanh toán tại bất kì cửa hàng tiện lợi nào gần nhất trong vòng{" "}
						<span> {expiredText}</span> kể từ lúc đặt chỗ.
					</p>
					<p className="step">
						3. Sau khi thanh toán, bạn sẽ nhận được thông báo đặt xe thành công và thông tin chủ xe qua tin nhắn và qua
						ứng dụng/website Mioto.
					</p>
					<p>
						Bấm vào{" "}
						<a
							href="https://payoo.vn/map/public/?verify=true"
							target="_blank"
							style={{ color: "#00a550", textDecoration: "underline" }}>
							đây
						</a>{" "}
						để tìm cửa hàng gần nhất chấp nhận thanh toán Payoo
					</p>
				</div>
				{/*
            <div className="summary-bill">
                <div className="img-store">
                    <a target="_blank" href="https://payoo.vn/map/public/?verify=true"><img className="img-fluid" src="https://n1-cstg.mioto.vn/m/store.png"/></a>
                </div>
                <div className="summary-countdown"> 
                    {isReserved && <span className="countdown"><label>Thời gian giữ chỗ</label><span>{this.props.countdown}</span></span>}
                    
                    <div className="d-flex">
                        <div className="summary"> 
                            <h4>TỔNG TIỀN </h4>
                            <p><NumberFormat value={trip.serviceType===2 ? trip.wd.priceSummary.deposit : trip.priceSummary.deposit} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /> </p>
                        </div>
                        <div className="link-payment ">
                            <button className={`btn btn--m ${isReserved ? "btn-secondary" : "btn-primary"}  btn-payment`} onClick={() => this.onReserveBtnClick({ tripId: trip.id, paymentMed: method.method, isCancel: isReserved }, method.providers[0].linkPayment)}>{isReserved ? "HỦY ĐẶT CHỖ" : "ĐẶT CHỖ"}</button>
                        </div>
                    </div>
                </div>
            </div>
*/}
				{err === commonErr.LOADING && <LoadingOverlay />}
				<MessageBox show={errMsg !== ""} error={err} message={errMsg} hideModal={this.hideMessageBox} />
			</div>
		);
	}
}

class OfficeMethod extends React.Component {
	constructor(props) {
		super();

		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			isReserved: props.trip.reserved === 1,
		};
	}

	hideMessageBox = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	onReserveBtnClick = (params) => {
		this.setState({
			err: commonErr.LOADING,
		});

		reserveTrip(params).then((paymentResp) => {
			const { error, errorMessage } = paymentResp.data;
			var { isReserved } = this.state;
			var errorMsg = errorMessage;
			if (error >= commonErr.SUCCESS) {
				isReserved = !isReserved;
				this.props.onReserveBtnClick(params);
				errorMsg = isReserved
					? `Đặt chỗ thành công, bạn vui lòng đặt cọc trực tiếp tại văn phòng Mioto trong vòng ${this.props.expiredText} kể từ lúc đặt chỗ.`
					: errorMessage;
			}

			this.setState({
				err: error,
				errMsg: errorMsg,
				isReserved: isReserved,
			});

			this.props.countDownReserve(params.tripId);
		});
	};

	render() {
		const { trip, method, expiredText } = this.props;
		const { isReserved, err, errMsg } = this.state;

		return (
			<div className="content-payment">
				<div className="step-by-step">
					<p className="step">
						1. Bấm <strong>"ĐẶT CHỖ"</strong> để xác nhận lựa chọn hình thức thanh toán tiền mặt tại văn phòng Mioto.
					</p>
					<p className="step">
						2. Bạn vui lòng đặt cọc trực tiếp tại văn phòng Mioto trong vòng <span>{expiredText}</span> kể từ lúc đặt
						chỗ.
					</p>
					<div className="cash-content">
						<div className="left">
							<div className="main-logo">
								{" "}
								<img loading="lazy" className="img-fluid" src={logo} />
							</div>
						</div>
						<div className="right">
							<p>Công ty CP Mioto Asia</p>
							<p>
								Địa chỉ: Văn phòng 02, Tầng 08, Tòa nhà Pearl Plaza, Số 561A Điện Biên Phủ, Phường 25, Quận Bình Thạnh,
								Thành phố Hồ Chí Minh, Việt Nam.
							</p>
							<p>Giờ làm việc: 9:00-17:00 (Thứ 2 - Thứ 7)</p>
						</div>
					</div>
					<p className="step">
						3. Sau khi nhận được tiền đặt cọc, Mioto sẽ thông báo đặt cọc thành công và thông tin chủ xe qua tin nhắn
						sms và qua ứng dụng/website Mioto.
					</p>
				</div>
				{/*
            <div className="summary-bill">
                <div className="img-store">
                </div>
                <div className="summary-countdown"> 
                    {isReserved && <span className="countdown"><label>Thời gian giữ chỗ</label><span>{this.props.countdown}</span></span>}
                    <div className="d-flex">
                        <div className="summary">
                            <h4>TỔNG TIỀN </h4>
                            <p><NumberFormat value={trip.serviceType===2 ? trip.wd.priceSummary.deposit : trip.priceSummary.deposit} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></p>
                        </div>
                        <div className="link-payment ">
                            <button className={`btn btn--m ${isReserved ? "btn-secondary" : "btn-primary"}  btn-payment`} onClick={() => this.onReserveBtnClick({ tripId: trip.id, paymentMed: method.method, isCancel: isReserved })}>{isReserved ? "HỦY ĐẶT CHỖ" : "ĐẶT CHỖ"}</button>
                        </div>
                    </div>
                </div>
            </div>
*/}
				{err === commonErr.LOADING && <LoadingOverlay />}
				<MessageBox show={errMsg !== ""} error={err} message={errMsg} hideModal={this.hideMessageBox} />
			</div>
		);
	}
}

class VoucherMethod extends React.Component {
	constructor(props) {
		super();
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			inputValue: "",
			activeProvider:
				props.activeVoucherProvider !== ""
					? props.method.providers.filter((item) => item.connectId === props.activeVoucherProvider)[0]
					: props.method.providers[0],
		};
	}

	componentDidMount() {
		this.props.getActiveOption(this.state.activeProvider);
		this.props.getActiveVoucherProvider(
			this.props.activeVoucherProvider !== "" ? this.props.activeVoucherProvider : this.state.activeProvider.connectId
		);
	}

	hideMessageBox = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	onChangeInput = (e) => {
		this.setState({
			inputValue: e.target.value,
		});
	};

	onProviderChange = (provider, tripId, oldProvider) => {
		this.setState({
			activeProvider: provider,
		});
		this.props.getActiveVoucherProvider(provider.connectId);
		this.props.getActiveOption(provider);
		this.checkCodes(tripId, "empty", oldProvider);
	};

	checkCodes = (tripId, inputValue, provider) => {
		this.props.checkCodes(tripId, inputValue, provider);
		this.setState({
			inputValue: "",
		});
	};

	render() {
		const { trip, method, deposit, codeStatus } = this.props;
		const { err, errMsg, inputValue, activeProvider } = this.state;
		return (
			<>
				<div className="line-payment"></div>
				<div className="content-payment">
					<div className="radio-payment">
						{method.providers.map((pro) => (
							<div key={pro.connectId} className="custom-radio">
								<input
									type="radio"
									id={`r_e_${pro.connectId}`}
									name={`${method.name}_${pro.connectId}_radio`}
									checked={activeProvider.connectId === pro.connectId}
									onChange={() => this.onProviderChange(pro, trip.id, activeProvider.connectId)}
								/>
								<label htmlFor={`r_e_${pro.connectId}`}>
									<img loading="lazy" className="e-wallet" src={pro.logo} alt={pro.name} />
								</label>
							</div>
						))}
					</div>
					<div className="gotit-payment">
						<div className="input-voucher">
							<input
								type="text"
								placeholder={`Nhập mã thẻ quà ${activeProvider.name}`}
								disabled={deposit < 1}
								value={inputValue}
								onChange={this.onChangeInput}
							/>
							<a
								className="btn btn--m btn-primary"
								disabled={!inputValue}
								onClick={() => this.checkCodes(trip.id, inputValue, activeProvider.connectId)}>
								Áp Dụng
							</a>
						</div>
						{(codeStatus === 1 || codeStatus === 2) && (
							<div className="error-text">
								<div className="wrap-svg">
									<IcInformationRed />
								</div>
								{/* code status 1: sử dụng 2: không hợp lệ */}
								<p className="text-danger">
									{codeStatus === 1 ? "Mã thanh toán đang được sử dụng" : "Mã không hợp lệ hoặc đã được sử dụng"}
								</p>
							</div>
						)}
					</div>
					{err === commonErr.LOADING && <LoadingOverlay />}
					<MessageBox show={errMsg !== ""} error={err} message={errMsg} hideModal={this.hideMessageBox} />
				</div>
			</>
		);
	}
}

const buildMethodContent = (
	trip,
	method,
	onReserveBtnClick,
	countDownReserve,
	countdown,
	cards,
	checkCodes,
	deposit,
	codeStatus,
	getActiveOption,
	getActiveVoucherProvider,
	activeVoucherProvider,
	enableTransferPayment
) => {
	var timeRemain = getCountDownTime(trip.timeExpired);
	var dateTimeObj = convertToDateTimeObj(timeRemain);
	var expiredText =
		(dateTimeObj.hours > 0 ? dateTimeObj.hours + " tiếng " : "") +
		(dateTimeObj.minutes > 0 ? dateTimeObj.minutes + " phút " : "");
	switch (method.method) {
		case paymentMethods.MY_CARD:
			return (
				<MyCardMethod trip={trip} method={method} cards={cards} deposit={deposit} getActiveOption={getActiveOption} />
			);

		case paymentMethods.INTERNATIONAL_CARD:
			return <InternationalMethod trip={trip} method={method} deposit={deposit} getActiveOption={getActiveOption} />;

		case paymentMethods.WALLET:
			return <WalletMethod trip={trip} method={method} deposit={deposit} getActiveOption={getActiveOption} />;

		case paymentMethods.DOMESTIC_BANK:
			return <DomesticBankMethod trip={trip} method={method} deposit={deposit} getActiveOption={getActiveOption} />;

		// case paymentMethods.STORE:
		//     return <StoreMethod trip={trip} method={method} onReserveBtnClick={onReserveBtnClick} countDownReserve={countDownReserve} countdown={countdown} expiredText={getCountDownTime(trip.timeExpired)/1000 < method.data.expiredInSeconds ? expiredText : method.data.expiredText}/>

		case paymentMethods.TRANFER:
			if (enableTransferPayment) {
				return (
					<TranferMethod
						trip={trip}
						method={method}
						onReserveBtnClick={onReserveBtnClick}
						countDownReserve={countDownReserve}
						countdown={countdown}
						expiredText={
							getCountDownTime(trip.timeExpired) / 1000 < method.data.expiredInSeconds
								? expiredText
								: method.data.expiredText
						}
					/>
				);} else {
				return;
			}

		// case paymentMethods.OFFICE:
		//     return <OfficeMethod trip={trip} method={method} onReserveBtnClick={onReserveBtnClick} countDownReserve={countDownReserve} countdown={countdown} expiredText={getCountDownTime(trip.timeExpired)/1000 < method.data.expiredInSeconds ? expiredText : method.data.expiredText}/>

		case paymentMethods.VOUCHER:
			return (
				<VoucherMethod
					trip={trip}
					method={method}
					getActiveOption={getActiveOption}
					getActiveVoucherProvider={getActiveVoucherProvider}
					activeVoucherProvider={activeVoucherProvider}
					checkCodes={checkCodes}
					deposit={deposit}
					codeStatus={codeStatus}
				/>
			);

		default:
			return (
				<div className="content-payment">
					<p>Không tìm thấy phương thức thanh toán</p>
				</div>
			);
	}
};

export default class Payment extends React.Component {
	constructor() {
		super();

		this.state = {
			step: 1,
			err: commonErr.INNIT,
			errMsg: "",
			methods: [],
			methodBoxes: [],
			cards: [],
			codes: [],
			activeVoucherProvider: "",
			codeStatus: 0, //0: ok, 1: duplicate, 2: invalid code
			activeOption: {},
			isReserved: false,
			errCode: commonErr.INNIT,
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.setState({
			err: commonErr.LOADING,
		});
		const { tripId } = this.props.match.params;
		if (!tripId) {
			this.setState({
				err: commonErr.FAIL,
				errMsg: "Không tìm thấy thông tin",
			});
		} else {
			getTripDetail(tripId).then((resp) => {
				const { data, error } = resp.data;
				if (error >= commonErr.SUCCESS && data) {
					const methodBoxes = [];
					if (data.trip.reservedMethod) {
						methodBoxes[data.trip.reservedMethod] = true;
					}
					this.setState({
						err: error,
						trip: data.trip,
						methodBoxes: methodBoxes,
						isReserved: data.trip.reserved,
					});
					getListPaymentMethod(tripId).then((pResp) => {
						if (pResp.data.data) {
							var methods = pResp.data.data;
							var methodsFilter = methods;
							const myCardMethods = {
								logo: card_method,
								method: paymentMethods.MY_CARD,
								name: "Thanh toán qua thẻ của tôi",
							};
							if (methods.some((method) => method.method === paymentMethods.MY_CARD)) {
								methodsFilter = methods.filter((method) => method.method !== paymentMethods.MY_CARD);
								methodsFilter.push(myCardMethods);
							}
							this.setState({
								err: pResp.error,
								methods: methodsFilter,
							});
						} else {
							this.setState({
								err: commonErr.FAIL,
								errMsg: "Không tìm thấy thông tin",
							});
						}
					});
					getListCard().then((myCardResp) => {
						if (myCardResp.data.error >= commonErr.SUCCESS && myCardResp.data.data.length > 0) {
							// if(this.state.trip && this.state.trip.reserved !== 1) {
							//     this.tooglePaymentMethodBox(paymentMethods.MY_CARD);                // auto open method MY_CARD
							// }
							this.setState({
								err: myCardResp.data.error,
								cards: myCardResp.data.data,
							});
						} else {
							this.setState({
								err: myCardResp.data.error,
								cards: null,
							});
						}
					});
				} else {
					this.setState({
						err: commonErr.FAIL,
						errMsg: "Không tìm thấy thông tin",
					});
				}
			});
			this.countDownReserve(tripId);
		}
	}

	tooglePaymentMethodBox = (box) => {
		const { methods, methodBoxes, trip, isOpenMyCard, codes } = this.state;

		if (trip.reserved === 1) {
			// && box !== trip.reservedMethod
			this.setState({
				err: commonErr.FAIL,
				errMsg: "Bạn cần HỦY ĐẶT CHỖ trước nếu muốn thay đổi phương thức thanh toán.",
			});
		} else if (codes.length > 0 && box === paymentMethods.TRANFER) {
			this.setState({
				err: commonErr.FAIL,
				errMsg:
					"Phương thức thanh toán Chuyển Khoản Ngân Hàng không áp dụng đồng thời với Mã Thanh Toán. Bạn vui lòng chọn phương thức khác hoặc không sử dụng Mã Thanh Toán.",
			});
		} else {
			if (box)
				for (var i = 0; i < methods.length; ++i) {
					if (methods[i].method !== box) {
						methodBoxes[methods[i].method] = false;
					}
				}

			methodBoxes[box] = !methodBoxes[box];

			this.setState({
				methodBoxes: {
					...methodBoxes,
				},
			});
		}
	};

	hideMessageBox = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	onReserveBtnClick = (params) => {
		this.setState({
			err: commonErr.LOADING,
		});
		reserveTrip(params).then((resp) => {
			const { error, errorMessage } = resp.data;
			var { isReserved, trip, methods } = this.state;

			var timeRemain = getCountDownTime(trip.timeExpired);
			var dateTimeObj = convertToDateTimeObj(timeRemain);
			var expiredText =
				(dateTimeObj.hours > 0 ? dateTimeObj.hours + " tiếng " : "") +
				(dateTimeObj.minutes > 0 ? dateTimeObj.minutes + " phút " : "");
			var TranferMethod = methods.filter((method) => method.method === paymentMethods.TRANFER);
			var expiredText =
				getCountDownTime(trip.timeExpired) / 1000 < TranferMethod[0].data.expiredInSeconds
					? expiredText
					: TranferMethod[0].data.expiredText;

			const tripNew = {
				...trip,
				reserved: isReserved ? 0 : 1,
			};

			if (error >= commonErr.SUCCESS) {
				isReserved = !isReserved;
				this.setState({
					err: error,
					errMsg: isReserved
						? `Đặt chỗ thành công. Bạn vui lòng chuyển khoản vào tài khoản Mioto trong vòng ${expiredText} để hoàn tất việc đặt xe. Xin cám ơn !`
						: errorMessage,
					isReserved: isReserved,
					trip: tripNew,
				});
			}
			this.countDownReserve(params.tripId);
		});
	};

	countDownReserve = (tripId) => {
		getTripDetail(tripId).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
				var reservedTimeExpired = resp.data.data.trip.reservedTimeExpired;
				if (reservedTimeExpired > 0) {
					var countDownDate = reservedTimeExpired;

					// Update the count down every 1 second
					var x = setInterval(() => {
						// Get todays date and time
						var timeRemain = getCountDownTime(countDownDate);
						var dateTimeObj = convertToDateTimeObj(timeRemain);
						// Display the result in the element with id="demo"
						this.setState({
							countdownInterval: x,
							countdown:
								(dateTimeObj.hours > 0 ? dateTimeObj.hours + ":" : "") +
								(dateTimeObj.minutes + ":") +
								dateTimeObj.seconds,
						});

						// If the count down is finished, write some text
						if (timeRemain < 0) {
							clearInterval(this.state.countdownInterval);
							this.setState({
								countdown: "Quá hạn",
							});
						}
					}, 1000);
				} else {
					clearInterval(this.state.countdownInterval);
					this.setState({
						countdown: "",
					});
				}
			}
		});
	};

	checkCodes = (tripId, inputValue, provider) => {
		const { codes } = this.state;
		const listCodes = codes.map((code) => code.code);
		this.setState({
			errCode: commonErr.LOADING,
		});
		if (listCodes.some((code) => code === inputValue)) {
			this.setState({
				errCode: commonErr.SUCCESS,
				codeStatus: 1, //duplicate
			});
		} else {
			listCodes.push(inputValue);
			const listCodesNew = listCodes.map((code) => code).join(";");
			checkCodes(tripId, inputValue === "empty" ? "empty" : listCodesNew, provider).then((resp) => {
				if (resp.data.error >= commonErr.SUCCESS) {
					if (codes.length !== resp.data.data.codes.length) {
						this.setState({
							errCode: resp.data.error,
							err: resp.data.error,
							codes: resp.data.data.codes,
							payWithCode: resp.data.data.payWithCode,
							deposit: resp.data.data.deposit,
							codeStatus: 0,
						});
					} else {
						this.setState({
							errCode: resp.data.error,
							codeStatus: inputValue === "empty" ? 0 : 2, // invalid code
						});
					}
				} else {
					this.setState({
						err: resp.data.error,
						errMsg: resp.data.errorMessage,
					});
				}
			});
		}
	};

	removeCode = (deleteCode) => {
		const { codes, trip, activeVoucherProvider } = this.state;
		this.setState({
			errCode: commonErr.LOADING,
		});
		const filterCodes = codes.filter((code) => code.code !== deleteCode);
		const filterCodesNew = filterCodes.map((code) => code.code).join(";");
		checkCodes(trip.id, filterCodes.length > 0 ? filterCodesNew : "empty", activeVoucherProvider).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS) {
				this.setState({
					err: resp.data.error,
					errCode: resp.data.error,
					codes: resp.data.data.codes,
					payWithCode: resp.data.data.payWithCode,
					deposit: resp.data.data.deposit,
					codeStatus: 0,
				});
			} else {
				this.setState({
					err: resp.data.error,
				});
			}
		});
		this.setState({
			codes: filterCodes,
		});
	};

	onDepositBtnClick = (tripId, cardId, linkPayment, codes, provider) => {
		this.setState({
			err: commonErr.LOADING,
		});
		const { deposit, methodBoxes, activeVoucherProvider } = this.state;
		const listCodes = codes.map((code) => code.code).join(";");
		if (deposit && deposit <= 0) {
			payWithOnlyCodes(tripId, listCodes, activeVoucherProvider).then((resp) => {
				if (resp.data.error < commonErr.SUCCESS) {
					this.setState({
						err: resp.data.error,
						errMsg: resp.data.errorMessage,
					});
				} else {
					this.props.history.push(`/trip/detail/${tripId}`);
					//redirect after successful payment
				}
			});
		} else {
			if (
				methodBoxes[paymentMethods.WALLET] === true ||
				methodBoxes[paymentMethods.DOMESTIC_BANK] === true ||
				methodBoxes[paymentMethods.INTERNATIONAL_CARD] === true
			) {
				requestPaymentWithUrlNew(linkPayment, tripId, listCodes, activeVoucherProvider).then((paymentResp) => {
					const { data, error, errorMessage } = paymentResp.data;
					if (error >= commonErr.SUCCESS && data) {
						window.location.assign(data.payUrl);
					} else {
						this.setState({
							err: error,
							errMsg: errorMessage,
						});
					}
				});
			} else if (methodBoxes[paymentMethods.MY_CARD] === true) {
				requestPaymentWithMyCard(tripId, cardId, listCodes, activeVoucherProvider).then((paymentResp) => {
					const { data, error, errorMessage } = paymentResp.data;
					if (error >= commonErr.SUCCESS && data) {
						window.location.assign(data.payUrl);
					} else {
						this.setState({
							err: error,
							errMsg: errorMessage,
						});
					}
				});
			}
		}
	};

	getActiveOption = (activeOption) => {
		this.setState({
			activeOption: activeOption,
		});
	};

	getActiveVoucherProvider = (provider) => {
		this.setState({
			activeVoucherProvider: provider,
		});
	};

	render() {
		var content;
		const {
			trip,
			methods,
			err,
			errCode,
			errMsg,
			countdown,
			cards,
			codes,
			activeVoucherProvider,
			deposit,
			codeStatus,
			methodBoxes,
			activeOption,
			isReserved,
		} = this.state;
		const disabled =
			(!deposit || deposit > 0) &&
			methodBoxes &&
			!methodBoxes[paymentMethods.WALLET] &&
			methodBoxes &&
			!methodBoxes[paymentMethods.DOMESTIC_BANK] &&
			methodBoxes &&
			!methodBoxes[paymentMethods.INTERNATIONAL_CARD] &&
			((methodBoxes && !methodBoxes[paymentMethods.MY_CARD]) || cards === null) &&
			methodBoxes &&
			!methodBoxes[paymentMethods.TRANFER];

			const timehourApproved = moment(trip?.timeApproved).hour()
			const timehourStart =  moment(trip?.tripDateFrom).hour()
			const date = (trip?.timeApproved - trip?.tripDateFrom)/3600000 <= 9 
			let enableTransferPayment = true; 

			if ((timehourApproved == 23 || timehourApproved < 6) && ( timehourStart < 8 && date)) {
				enableTransferPayment = false; 
			}
		content = (
			<div className="payment-section sec space">
				<div className="step-container">
					<div className="m-container">
						<StepBarStatus active={1} />
					</div>
				</div>

				<div className="payment-container">
					<div className="m-container">
						<h3>Chọn Phương Thức Thanh&nbsp;Toán</h3>
					</div>
					<div className="payment-mobile">
						<div className="m-container">
							<div className="payment-module">
								<div className="payment-method" style={{ maxHeight: "unset", overflow: "unset" }}>
									{this.state.err === commonErr.LOADING && <LoadingOverlay />}

									{methods.map((method, i) => {
										const isOpen = this.state.methodBoxes[method.method];
										if (method.method === "Tranfer" && !enableTransferPayment) {
											return; 
										} else {
										return (
											<div key={i} className={`payment-method__item ${isOpen ? "active" : ""}`}>
												<div
													className="title-payment"
													onClick={() => {
														this.tooglePaymentMethodBox(method.method);
													}}>
													<img loading="lazy" src={method.logo} alt={method.name} />
													<h6>{method.name}</h6>
												</div>
												{isOpen &&
													buildMethodContent(
														trip,
														method,
														this.onReserveBtnClick,
														this.countDownReserve,
														countdown,
														cards,
														this.checkCodes,
														deposit,
														codeStatus,
														this.getActiveOption,
														this.getActiveVoucherProvider,
														activeVoucherProvider, 
														enableTransferPayment
													)}
											</div>
										);
										}
									})}

									<p className="payment-method__note">
										*Gọi <a href="tel:19009217">19009217 (7AM - 10PM) </a>hoặc Chat với Mioto tại{" "}
										<a target="_blank" href="https://www.messenger.com/t/mioto.vn">
											Mioto Fanpage{" "}
										</a>
										nếu bạn gặp khó khăn trong quá trinh thanh toán.
									</p>

									<MessageBox show={errMsg !== ""} error={err} message={errMsg} hideModal={this.hideMessageBox} />
								</div>
								{/* <div className="link-manage">
									<Link className="btn btn-default btn--m" to={`/trip/detail/${trip ? trip.id : ""}`} >Quản lý chuyến</Link>
								</div> */}

								<StickyContainer
									className="payment-total"
									style={{ height: "unset", padding: 0, background: "unset", borderRadius: 0 }}>
									<Sticky>
										{({ style }) => (
											<div
												style={{
													...style,
													display: "flex",
													flexDirection: "column",
													gap: "16px",
													background: "#ffffff",
													borderRadius: "12px",
													padding: "24px 16px",
												}}>
												{codes && (
													<div className="gotit-container">
														<p className="title">Mã thanh toán </p>
														{errCode === commonErr.LOADING && <LoadingInline />}
														{codes.map((code) => (
															<div key={code.code} className="gotit-code">
																<div className="code">
																	<p>{code.code}</p>
																	<div className="wrap-svg" onClick={() => this.removeCode(code.code)}>
																		<IcCloseBlack />
																	</div>
																</div>
																<p className="price-discount">
																	--{" "}
																	<NumberFormat
																		value={code.amount}
																		displayType={"text"}
																		thousandSeparator={" "}
																		decimalSeparator={","}
																		suffix={"đ"}
																	/>
																</p>
															</div>
														))}
														{codes.length > 0 && (
															<p className="note-gotit">
																{deposit > 0
																	? "Số tiền thanh toán bằng Mã Thanh Toán chưa đủ. Bạn cần bổ sung thêm mã thanh toán hoặc chọn thêm 1 phương thức thanh toán khác(trừ phương thức Chuyển khoản) để tiếp tục."
																	: "Số tiền thanh toán bằng Mã Thanh Toán còn dư(nếu có) sẽ được cấn trừ vào phần thanh toán sau với chủ xe."}{" "}
															</p>
														)}
													</div>
												)}
												<div className="total-price">
													<p>Tổng giá trị</p>
													{trip && (
														<p className="total">
															<NumberFormat
																value={
																	!deposit
																		? trip.serviceType === 2
																			? trip.wd.priceSummary.deposit
																			: trip.priceSummary.deposit
																		: deposit > 0
																		? deposit
																		: 0
																}
																displayType={"text"}
																thousandSeparator={" "}
																decimalSeparator={","}
																suffix={"đ"}
															/>
														</p>
													)}
												</div>
												{methodBoxes[paymentMethods.TRANFER] ? (
													isReserved ? (
														<a
															onClick={() =>
																this.onReserveBtnClick({
																	tripId: trip.id,
																	paymentMed: paymentMethods.TRANFER,
																	isCancel: true,
																})
															}
															className="btn btn--m btn-secondary">
															Hủy đặt chỗ
														</a>
													) : (
														<a
															onClick={() =>
																this.onReserveBtnClick({
																	tripId: trip.id,
																	paymentMed: paymentMethods.TRANFER,
																	isCancel: false,
																})
															}
															className="btn btn--m btn-primary">
															Đặt chỗ
														</a>
													)
												) : (
													<a
														disabled={disabled}
														onClick={() =>
															this.onDepositBtnClick(
																trip.id,
																activeOption.cardId ? activeOption.cardId : null,
																activeOption.linkPayment ? activeOption.linkPayment : null,
																codes,
																activeVoucherProvider
															)
														}
														className="btn btn--m btn-primary">
														Thanh toán
													</a>
												)}
												<p className="note fontWeight-7">
													(*Trường hợp nhiều khách đặt xe cùng một thời điểm, hệ thống sẽ ưu tiên khách hàng thanh toán
													sớm nhất)
												</p>
												<p className="note fontWeight-7">
													(*Để bảo vệ khoản thanh toán của bạn, tuyệt đối không chuyển tiền hoặc liên lạc bên ngoài
													trang web hoặc ứng dụng Mioto)
												</p>
											</div>
										)}
									</Sticky>
								</StickyContainer>
							</div>
						</div>
					</div>
				</div>
			</div>
		);

		return (
			<div className="mioto-layout">
				<Header />
				{content}
				<Footer />
			</div>
		);
	}
}
